'use client';

import { signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';

import { Typography } from '@/app/components/ui/Typography';

export default function InternalSignInLink() {
  const t = useTranslations();

  const handleSSOSignIn = (e: React.MouseEvent) => {
    e.preventDefault();
    void signIn('moi', undefined, {
      acr: 'urn:se:curity:authentication:saml2:oura_google',
    });
  };

  return (
    <Typography className="text-md text-center">
      <button
        type="button"
        className="rounded font-semibold underline focus:outline-none focus:ring-2 focus:ring-helsinki-blue focus:ring-offset-2"
        onClick={handleSSOSignIn}
        data-testid="internal-sso-link"
      >
        {t('signin_internal_sso_link')}
      </button>
    </Typography>
  );
}
